/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:34
 * @LastEditors: linxi
 * @LastEditTime: 2025-11-27 15:04:33
 */
/* eslint-disable react/display-name */
import { Button, Popover, Switch, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { getAge } from '../../../../utils/StringUtils'
import { DateTimeFormatSimples } from '../../../../models/datetime'
import { QuestionCircleTwoTone } from '@ant-design/icons'

type ScanRateAction = 'lookDetail'
export const ScanRateColumn = (onAction: (action: ScanRateAction, t: any) => void): TableColumnType<any>[] => {
  const Tips = (title: string, key?: any) => (
    <>
      {title}
      <Popover
        placement='top'
        content={key == 'gatherTraceCodeCount' ? '仅包含采集了追溯码并且已上传至医保的数据' : key == 'noTraceCodeMedicineCount' ? '勾选无码的药品' : key == 'notGatherTraceCodeCount' ? '包含未上传至医保的数据和未采集追溯码但已上传至医保的数据' : ''}
      >
        <QuestionCircleTwoTone style={{ marginLeft: '5px' }} />
      </Popover>
    </>
  )
  return [
    {
      title: '销售品种数',
      dataIndex: 'salesVarietiesCount',
      width: '12em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.salesVarietiesCount > 0 ? r?.salesVarietiesCount : '-'
      },
    },
    {
      title: '销售总数量',
      dataIndex: 'salesTotalCEILCount',
      width: '12em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.salesTotalCEILCount > 0 ? r?.salesTotalCEILCount : '-'
      },
    },
    {
      title: Tips('已采追溯码', 'gatherTraceCodeCount'),
      dataIndex: 'gatherTraceCodeCount',
      width: '12em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.gatherTraceCodeCount > 0 ? r?.gatherTraceCodeCount : '-'
      },
    },
    {
      title: Tips('无码药品数', 'noTraceCodeMedicineCount'),
      dataIndex: 'noTraceCodeMedicineCount',
      width: '12em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.noTraceCodeMedicineCount > 0 ? r?.noTraceCodeMedicineCount : '-'
      },
    },
    {
      title: Tips('应采未采追溯码记录', 'notGatherTraceCodeCount'),
      dataIndex: 'notGatherTraceCodeCount',
      width: '12em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.notGatherTraceCodeCount > 0 ? r?.notGatherTraceCodeCount : '-'
      },
    },
    {
      title: '采集率',
      dataIndex: 'acquisitionRate',
      width: '12em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return <span style={{ color: '#f39935' }}>{r?.acquisitionRate ? r?.acquisitionRate : '-'}</span>
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '12em',
      dataIndex: '',
      key: '',
      render: function Element(_, t) {
        return <>
          <Button
            type='text'
            size='small'
            style={{ color: '#027AFF', fontSize: '14px' }}
            onClick={() => {
              onAction('lookDetail', t)
            }}
          >
            查看无追溯码记录
          </Button>
        </>
      },
    },

  ]
}

export const UploadRateColumns = (v?: any): TableColumnType<any>[] => {
  return [

    {
      title: '追溯码总数',
      dataIndex: 'traceTotal',
      width: '5em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.traceTotal > 0 ? r?.traceTotal : '-'
      },
    },
    {
      title: '已上传总数',
      dataIndex: 'traceHasUploadTotal',
      width: '5em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.traceHasUploadTotal > 0 ? r?.traceHasUploadTotal : '-'
      },
    },
    {
      title: '未上传总数',
      dataIndex: 'traceNoUploadTotal',
      width: '6em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.traceNoUploadTotal > 0 ? r?.traceNoUploadTotal : '-'
      },
    },
    {
      title: '上传率',
      key: 'traceUploadRate',
      width: '8em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return <span style={{ color: '#f39935' }}>{r?.traceUploadRate ? r?.traceUploadRate : '-'}</span>
      },
    },
  ]
}

type Action = 'traceCode'

export const NoTraceCodeRecordColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void,
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '6rem',
      fixed: 'left',
      render: (_1, _2, i) => `${startIndex + i + 1}`,
    },
    {
      title: '患者姓名',
      dataIndex: 'patientName',
      width: '12em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.patientName ? r?.patientName : '-'
      },
    },
    {
      title: '年龄',
      dataIndex: 'ageYear',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return getAge(r?.ageYear, r?.ageMonth)
      },
    },
    {
      title: '结算时间',
      dataIndex: 'createTime',
      key: 'createTime',
      align: 'center',
      ellipsis: true,
      width: '10rem',
      render: (_, r) => {
        return r?.payTime ? moment(r?.payTime).format(DateTimeFormatSimples) : '-'
      },
    },
    {
      title: '应采数量',
      dataIndex: 'shouldCollect',
      width: '10em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.shouldCollect ? r?.shouldCollect : '-'
      },
    },
    {
      title: '实采数量',
      dataIndex: 'actualCollect',
      width: '10em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.actualCollect >= 0 ? r?.actualCollect : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '16em',
      dataIndex: '',
      key: '',
      render: function Element(_, t) {
        return <>
          <Button
            style={{ marginLeft: '10px' }}
            type='primary'
            size='small'
            onClick={() => {
              onAction('traceCode', t)
            }}
          >
            追溯码
          </Button>
        </>
      },
    },

  ]
}

